export default {
    getActiveInfo(params) {
      return new Promise((resolve, reject) => {
         axios.get('/api/huodong/gr',{
            params:params
        })
         .then((response) => {
            resolve(response)
        })
     }, err => {
         reject(err)
     })
  },
  activePost(params) {
    return new Promise((resolve, reject) => {
        axios.post('/api/huodong/gr-sign',params)
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},

getActiveAudit(params) {
  return new Promise((resolve, reject) => {
     axios.get('/api/huodong/gr-info',{
        params:params
    })
     .then((response) => {
        resolve(response)
    })
 }, err => {
     reject(err)
 })
},

}